import { TGetOrderResponse } from '@p2p/services';

// P2P-3043: готовая QR-картинка провайдера (Viatrum PAYMENT_LINK — QR внутри банка,
// перевод во Вьетнам). Реквизита у такой заявки нет (в requisite — общая заглушка),
// поэтому страница уходит на экран «Оплата по QR-коду», показывает картинку как есть
// (QR провайдера не перекодируем — P2P-2580/2597) и прячет блок реквизитов.
// Бэкенд отдаёт ссылку, а не провайдера (P2P-2101).
export const getProviderQrImageUrl = (
  order: Pick<TGetOrderResponse, 'qr_image_url'>,
): string | null => {
  const url = order.qr_image_url?.trim();

  return url ? url : null;
};

export const hasProviderQrImage = (order: Pick<TGetOrderResponse, 'qr_image_url'>): boolean =>
  getProviderQrImageUrl(order) !== null;
